import { Box, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import MedicationOutlinedIcon from '@mui/icons-material/MedicationOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import FeedbackButton from '../utils/feedbackButton';

const sections = [
  {
    title: 'Patient',
    items: [
      { label: 'Overview', value: 'overview', icon: <DashboardOutlinedIcon /> },
      { label: 'Documentation', value: 'notes', icon: <DescriptionOutlinedIcon /> },
      { label: 'Observations', value: 'observations', icon: <MonitorHeartOutlinedIcon /> },
    ],
  },
  {
    title: 'Results',
    items: [
      { label: 'Blood Results', value: 'bloods', icon: <ScienceOutlinedIcon /> },
      { label: 'Radiology', value: 'imaging', icon: <ImageOutlinedIcon /> },
    ],
  },
  {
    title: 'Management',
    items: [
      { label: 'Medication Chart', value: 'meds', icon: <MedicationOutlinedIcon /> },
    ],
  },
];

export default function Sidebar({ onSelect, activeTab }) {
  return (
    <Box
      sx={{
        width: 200,
        height: '100%',
        borderRight: '1px solid #e5e7eb',
        bgcolor: '#f8fafc',
        display: 'flex',
        flexDirection: 'column',
        px: 1.5,
        py: 2,
      }}
    >
      {sections.map((section) => (
        <Box key={section.title} sx={{ mb: 2 }}>
          <Typography
            variant="caption"
            sx={{
              px: 1,
              mb: 0.75,
              display: 'block',
              color: 'text.secondary',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
            }}
          >
            {section.title}
          </Typography>

          {section.items.map((item) => {
            const active = activeTab === item.value;

            return (
              <Box
                key={item.value}
                onClick={() => onSelect(item.value)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.25,
                  px: 1.25,
                  py: 1,
                  borderRadius: 2,
                  cursor: 'pointer',
                  transition: '0.15s ease',
                  bgcolor: active ? '#dbeafe' : 'transparent',
                  border: active ? '1px solid #60A5FA' : '1px solid transparent',

                  '&:hover': {
                    bgcolor: '#eef2ff',
                  },
                }}
              >
                <Box sx={{ color: active ? '#2563eb' : 'text.secondary' }}>
                  {item.icon}
                </Box>

                <Typography
                  sx={{
                    fontWeight: active ? 700 : 500,
                    fontSize: 14,
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            );
          })}
          <Box
            sx={{
              position: 'fixed',
              bottom: 20,
              left: 20,
              zIndex: 2000,
            }}
          >
            <FeedbackButton page="Participant live screen" />
          </Box>
        </Box>
      ))}
    </Box>
  );
}